import { MatchReportUpdateSalesBOM } from '@pages/ManageProductPage/SalesBOMPage/MatchReportUpdateSalesBOM';
import { useManageProductPageAnalytics } from '@services/useManageProductPageAnalytics';
import { useEffect } from 'react';

export function SalesBOM() {
  const { sendLandedSalesBOMMatchReportEvent } = useManageProductPageAnalytics();

  useEffect(() => {
    sendLandedSalesBOMMatchReportEvent();
  }, [sendLandedSalesBOMMatchReportEvent]);

  return <MatchReportUpdateSalesBOM />;
}
